/**
 * Adzuki.CharacterCount
 */

(function CharacterCount($, Adzuki)
{
	"use strict";

	var charCount = function _charCount(el, options)
	{
		var $el, $label, opts, defaults = {
			max       : 255,
			label     : null,
			label_text: 'characters remaining',
		};

		try
		{
			opts = $.extend({}, defaults, options);

			if (!opts.label) {
				throw new Error('missing required label');
			}

			if (typeof el === 'string') {
				$el = $(el);
			}
			else if (typeof el === 'object' && (el instanceof jQuery)) {
				$el = el;
			}

			if (!$el.length) {
				throw new Error('cannot find el');
			}

			if (typeof opts.label === 'string') {
				$label = $(opts.label);
			}
			else if (typeof opts.label === 'object' && (opts.label instanceof jQuery)) {
				$label = opts.label;
			}

			if (!$label.length) {
				throw new Error('cannot find label');
			}

			// set maxlength attribute on $el
			$el.attr('maxlength', opts.max);

			// set initial label text
			$label.html(opts.max+' '+opts.label_text);

			// update label text
			$el.on('input', updateLabel);

			// update on load
			updateLabel();
		}
		catch (err) {
			console.error('[Adzuki.CharacterCount]', err);
		}


		function updateLabel() {
			var remaining = (opts.max - $el.val().length);
			$label.html(remaining+' '+opts.label_text);
			$label.css('color', ((remaining <= 10) ? 'red' : ''));
		}
	};

	Adzuki.CharacterCount = charCount;
}(jQuery, window.Adzuki || {}));
